<template>
	<div class="cart-residential-item">
		<div class="cart-residential-menu-header">
			<div>{{ menu.name }}</div>
			<div>{{ menu.formattedDow }} {{ menu.scheduleRange }}</div>
		</div>
		<CheckoutItem
			v-for="item in items"
			:key="item.uuid"
			:item="item"
			:showRestaurantName="false"
		/>
	</div>
</template>

<style scoped>
.cart-residential-menu-header {
	padding: 0 25px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 50px;
	background: var(--sk-grey-bg);
	border-bottom: 1px solid var(--gR-white2);
}

.cart-residential-menu-header > div:first-child {
	font-size: 13px;
	color: var(--gR-base-80);
	font-weight: 600;
}

.cart-residential-menu-header > div:last-child {
	font-size: 12px;
	color: var(--sk-grey3);
}

.cart-residential-item >>> .checkout-item {
	background: var(--gR-white);
	border-bottom: 1px solid var(--gR-white2);
}
</style>

<script>
import moment from "moment"
import momentUtils from "@/moment-utils"
import CheckoutItem from "@/components/checkout/CheckoutItem.vue"

export default {
	name: "CartResidentialItem",
	components: {
		CheckoutItem
	},
	props: {
		items: Array,
		menuId: Number,
		date: String
	},
	computed: {
		restaurant() {
			return this.$store.state.restaurants && this.items.length > 0
				? this.$store.state.restaurants[this.items[0].restaurant_id]
				: null
		},
		menu() {
			if (this.menuId > -1) {
				const menuSchedule =
					this.$store.state.menuSchedules[this.menuId]
				const menuHashItem = this.$store.getters.menusHash[this.menuId]
				const date = moment(this.date, "YYYY-MM-DD")
				const dow = momentUtils.normalizeDayOfWeek(date)
				const inStock = menuHashItem.menu.stock_status == 1
				const todaysDow = momentUtils.todaysDow()
				const isToday = todaysDow == dow
				const timeSlots = momentUtils.generateTimeSlots(
					menuSchedule[dow],
					inStock,
					isToday
				)
				let scheduleRange = ""
				if (timeSlots.length > 1) {
					scheduleRange = `${timeSlots[0].text} - ${
						timeSlots[timeSlots.length - 1].text
					}`
				} else if (timeSlots[0]) {
					scheduleRange = timeSlots[0].text
				}
				return {
					id: this.menuId,
					name: menuHashItem.menu.name,
					formattedDow: date.format("dddd"),
					scheduleRange: scheduleRange
				}
			}
			return null
		}
	}
}
</script>